import { createContext, useContext, useEffect } from 'react'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'
import { v4 as uuid } from 'uuid'
import useUser from 'user-module/user/core/useUser'
import { getEnv } from 'spypoint/src/setLaunchDarklyEnv'

const FlagsContext = createContext({})

export const useLDFlags = () => useContext(FlagsContext)

const FlagsProviderApp = ({ children, ldClient }) => {
  const user = useUser()

  useEffect(() => {
    if (ldClient && user?.id) {
      const ctx = {
        kind: 'multi', // Indicates multiple contexts
        user: {
          kind: 'user',
          key: user.id,
          email: user.email,
          _meta: {
            privateAttributes: ['email'],
          },
          env: getEnv(),
          application: {
            name: 'webapp',
            product: 'spypoint',
          },
        },
        source: {
          kind: 'source',
          key: uuid(),
          platform: 'Web',
        },
      }

      ldClient.identify(ctx).catch((err) => {
        console.error('Error identifying LaunchDarkly context:', err)
      })
    }
  }, [ldClient, user?.id])

  const flags = ldClient?.allFlags()

  return (
    <FlagsContext.Provider value={{ flags }}>
      { children }
    </FlagsContext.Provider>
  )
}

export const FlagsProvider = withLDConsumer()(FlagsProviderApp)
